export const IconHouseSidebar = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 14.1668V10.8335"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66663 6.66673L9.77638 2.61187C9.91713 2.54149 10.0828 2.54148 10.2235 2.61187L18.3333 6.66673"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 9.1665V15.8332C16.6667 16.7537 15.9205 17.4998 15 17.4998H5.00004C4.07957 17.4998 3.33337 16.7537 3.33337 15.8332V9.1665"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
